module.exports = __webpack_public_path__ + "e0106718/img/question-icon.06c20c5d.svg";